import React, { useCallback, useMemo } from 'react'
import { Row, Col, Button, Flex } from 'antd'
import ModalFullScreen from '../../components/Modal/ModalFullScreen'
import { useGetUsageData } from '../../hooks/UsageMonitor'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { FormattedMessage } from 'react-intl'
import { Loadable } from '../../components/Loading'
import MostViewedSubsystem from './MostViewedSubsystem'

export const FullScreenSubsystemWidget = ({
  toggleModalFunc,
  startTime,
  endTime,
  showDetailsOn,
}) => {
  const { allUsageData, isLoading } = useGetUsageData(startTime, endTime)
  const sortedData = useMemo(() => {
    const groupedData = {}
    if (allUsageData && Array.isArray(allUsageData)) {
      allUsageData.forEach((data) => {
        if (!groupedData[data.eventType]) groupedData[data.eventType] = [data]
        else groupedData[data.eventType].push(data)
      })
    }
    return groupedData
  }, [allUsageData])

  const content = useCallback(() => {
    return (
      <Row className="usage-monitor-full-screen-body">
        <Col className="usage-monitor-full-screen-body-right"></Col>
        <Col className="usage-monitor-full-screen-body-left">
          <Loadable isLoading={isLoading && allUsageData} showText={false}>
            <Flex
              className="usage-monitor-full-screen-body-left-top"
              vertical={false}
              justify="center"
              align="center"
            >
              <MostViewedSubsystem
                allData={sortedData}
                showDetailsOn={showDetailsOn}
                isFullScreen={true}
              />
            </Flex>
            <div className="usage-monitor-full-screen-body-left-bottom"></div>
          </Loadable>
        </Col>
      </Row>
    )
  }, [allUsageData, isLoading, showDetailsOn, sortedData])

  const header = useCallback(() => {
    return (
      <>
        <Row>
          <Col>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                toggleModalFunc(false)
              }}
            >
              <FormattedMessage id="generic.back" />
            </Button>
          </Col>
        </Row>
      </>
    )
  }, [toggleModalFunc])

  return (
    <ModalFullScreen
      HeaderProp={header}
      ContentProp={content}
      isOpen={true}
      dataTestIdContainer={'usage-monitor-subsystems-modal'}
      dataTestIdHeader={'usage-monitor-subsystems-modal-header'}
      dataTestIdContent={'usage-monitor-subsystems-modal-content'}
    />
  )
}
